function DashboardActiveMainDriver({value}) {
    return (
        <div className="flex items-center justify-between gap-6 rounded-xl border border-[#324d67] bg-[#111a22]/80 p-4 shadow-xl shrink-0">
            <div className="flex items-center gap-4">
                <div className="size-10 rounded-lg bg-primary/20 border border-primary/30 flex items-center justify-center">
                    <span className="material-symbols-outlined text-primary">sports_score</span>
                </div>
                <div className="flex flex-col">
                    <span className="text-[10px] uppercase text-[#92adc9] font-bold leading-none mb-1">Current Driver</span>
                    <span className="text-xl font-bold tracking-tight text-white uppercase">{value["player-name"]} {value["player-surname"]}</span>
                </div>
            </div>
            <div className="flex flex-col border-l border-[#233648] pl-6">
                <span className="text-[10px] uppercase text-[#92adc9] font-bold leading-none mb-1">Vehicle Specification</span>
                <span className="text-lg font-bold tracking-tight text-white italic capitalize">{typeof value["car-name"] === 'string' ? value["car-name"].replaceAll('_', ' ') : value["car-name"]}</span>
            </div>

            {value["is-online"] == 1 ?
                <div className="flex items-center gap-3 px-4 py-2 bg-[#1a2b3c] rounded-lg border border-[#324d67] ml-auto">
                    <span className="material-symbols-outlined text-acc-green">network_check</span>
                    <div className="flex flex-col">
                        <span className="text-[9px] uppercase text-[#92adc9] font-bold leading-none">Latency</span>
                        <span className="text-sm font-black text-acc-green tracking-tight">{Math.trunc(value.ping)}ms</span>
                    </div>
                </div>

                :

                <div className="flex items-center gap-3 px-4 py-2 rounded-lg ml-auto"></div>
            }
        </div>
    );
}

export default DashboardActiveMainDriver;